import React, {useState, useEffect, Fragment} from 'react'

import withCategory from '../../hoc/with-category'

import FeaturedMenuItem from './featured-menu-item'

const FeaturedMenu = ({categoryList, currentCategoryId, handleMenuClick}) => {
  const
    [categories, setCategories] = useState([]);

  useEffect(() => {
    if (categoryList) {
      setCategories([{'id': 'all', 'title': 'Все'}, ...categoryList])
    }
  }, [categoryList]);

  const itemList = categories.map(category => {
    const classActive = `${category.id}` === currentCategoryId && 'new-deals__menu-item_active';

    return (
      <FeaturedMenuItem className={`new-deals__menu-item ${classActive}`}
                        handleMenuClick={handleMenuClick}
                        title={category.title}
                        id={category.id} key={category.id}/>
    )
  });

  return (
    <Fragment>
      {categories.length && <h2 className="h2">Новинки</h2>}
      <div className="new-deals__menu">
        <ul className="new-deals__menu-items">
          {itemList}
        </ul>
      </div>
    </Fragment>
  )
};

export default withCategory(FeaturedMenu)
